module.exports = __webpack_public_path__ + "static/media/tec-mundo_banner.80fb88f3.svg";